import { AppState } from 'types/app';
import { FEATURE_MAFIA_AKAMAI } from 'constants/features';

export const selectFeature = (feature: string, state: AppState) => state.features?.[feature];

export const selectIsFeatureMafiaAkamai = (state: AppState) => selectFeature(FEATURE_MAFIA_AKAMAI, state);
